// eslint-disable-next-line import/no-unresolved
import gql from 'graphql-tag';

export const UPDATE_USER_LAST_LOGIN = gql`
  mutation UpdateUserMutation($userId: String!, $lastLogin: String) {
    updateUserLastLogin(userID: $userId, lastLogin: $lastLogin) {
      _id
    }
  }
`;